export const ProcessTypeInput = [
    {name:'Make To Stock',value:'MTS'},{name : 'Make To Order',value:'MTO'}
    // ,{name : 'Samples',value:'Samples'}
]